
export function initializaDisplayPayLink(sessionId) {

  var iframe = document.createElement('iframe');



  iframe.style.position = 'fixed';
  iframe.style.inset = '0px';
  iframe.style.border = 'none';
  iframe.style.height = '100%';
  iframe.style.display = 'none';
  iframe.style.width = '100%';
  iframe.style.zIndex = '8482607753';
  iframe.id = 'CabbageLink';

  iframe.src = 'https://cdn.cabbagepay.com/session/' + sessionId;
  document.body.appendChild(iframe);

}

export function displayPayLink(sessionId) {


  document.getElementById("CabbageLink").style.display = "table";



}

export function removeIFrame() {
  //var iframe = document.getElementById("CabbageLink");
  //document.body.removeChild(iframe);
  document.getElementById("CabbageConnectLink").style.display = "none";
  document.getElementById("CabbageLink").style.display = "none";

}



export function verifyLink(sessionId) {

  document.getElementById("CabbageLink").style.display = "table";


}



export function initializaVerifyLink(sessionId) {

  var iframe = document.createElement('iframe');



  iframe.style.position = 'fixed';
  iframe.style.inset = '0px';
  iframe.style.border = 'none';
  iframe.style.height = '100%';
  iframe.style.display = 'none';

  iframe.style.width = '100%';
  iframe.style.zIndex = '8482607753';
  iframe.id = 'CabbageLink';

  iframe.src = 'https://cdn.cabbagepay.com/verify/' + sessionId;
  document.body.appendChild(iframe);

}

//window.addEventListener('message', function (e) {
//  console.log(e)
//  const data = JSON.parse(e.data);
//  console.log(data)

//  // Where does the message come from
//  //const channel = data.channel;
//});



export function initializaConnectPayLink(sessionId) {

  var iframe = document.createElement('iframe');



  iframe.style.position = 'fixed';
  iframe.style.inset = '0px';
  iframe.style.border = 'none';
  iframe.style.height = '100%';
  iframe.style.display = 'none';
  iframe.style.width = '100%';
  iframe.style.zIndex = '8482607753';
  iframe.id = 'CabbageConnectLink';

  iframe.src = 'https://cdn.cabbagepay.com/connect/' + sessionId;
  document.body.appendChild(iframe);

}


export function displayConnectLink(sessionId) {


  document.getElementById("CabbageConnectLink").style.display = "table";



}
